import React from 'react'
import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import { toast } from 'react-toastify'

const ExportCSV = ({
  csvData,
  fileName,
  wscols,
  headerTitle,
  headerTranslate
}) => {
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  const fileExtension = '.xlsx'

  const Heading = headerTranslate

  const exportToCSV = (csvData, fileName, wscols) => {
    if (!csvData) {
      toast.warn('Không có dữ liệu để xuất!!', {
        position: 'top-center',
        autoClose: 3000
      })
    }
  
    // Lọc dữ liệu để chỉ lấy các cột có trong headerTitle
    const filteredData = csvData.map((row) =>
      headerTitle.reduce((acc, key) => {
        acc[key] = row[key] !== undefined ? row[key] : null; // Lấy giá trị hoặc đặt null nếu không tồn tại
        return acc;
      }, {})
    );
  
    // Tạo worksheet từ Heading
    const ws = XLSX.utils.json_to_sheet(Heading, {
      header: headerTitle,
      skipHeader: true,
      origin: 0,
    });
  
    // Set độ rộng cột
    ws['!cols'] = wscols;
  
    // Thêm dữ liệu JSON đã lọc vào worksheet
    XLSX.utils.sheet_add_json(ws, filteredData, {
      header: headerTitle,
      skipHeader: true,
      origin: -1,
    });
  
    // Thiết lập định dạng dữ liệu (nếu cần)
    const range = XLSX.utils.decode_range(ws['!ref']); // Lấy phạm vi của sheet
    for (let row = 1; row <= range.e.r; row++) {
      const cellAddress = XLSX.utils.encode_cell({ r: row, c: 2 }); // Cột thứ 3 (index 2)
      if (ws[cellAddress]) {
        ws[cellAddress].t = 'n'; // Đặt kiểu dữ liệu là số
        ws[cellAddress].z = '0'; // Không có chữ số thập phân
      }
    }
  
    // Tạo workbook và ghi dữ liệu vào file
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  }

  return (
    <button
      className="btn btn-success"
      type="button"
      onClick={(e) => exportToCSV(csvData, fileName, wscols)}
    >
      Xuất Excel
    </button>
  )
}

export default ExportCSV

